<template>
  <div class="awardItem" @click="handleClick">
    <div class="awardIcon">
      <Award :awardData="awardData" />
    </div>
    <div class="main">
      <div class="titleArea">
        <span class="label">权益卡</span>
        <span class="title">{{ awardData.title }}</span>
      </div>
      <div class="time">
        {{ awardData.startTime | formatTime }}-{{
          awardData.endTime | formatTime
        }}
      </div>
      <button
        v-if="awardData.rewardType === 'ENTITY'"
        class="btn"
        @click="handleGoAddressPage"
      >
        {{ btnText }}
      </button>
      <button
        v-else-if="awardData.rewardType === 'COUPON'"
        class="btn"
        @click="handleUseCoupon(awardData)"
      >
        去使用
      </button>
      <button
        v-else-if="awardData.clickUrl"
        class="btn"
        @click="handleUseAward(awardData)"
      >
        去使用
      </button>
    </div>
  </div>
</template>

<script>
import Award from '../awardItem/Award';
import { formatTime } from '@/utils';
import { COUPON_NAME, AWARD_NAME } from '../../constants';
import { toDayDate } from '../../utils';
import { useCoupon } from '@/components/js/lalaPrize/lalaCoupon';

export default {
  components: { Award },
  props: {
    awardData: {
      type: Object,
      required: true
    },
    actEndTimeStr: {
      type: String,
      required: true
    },
    isHasUserAddress: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    labelText() {
      if (this.awardData.rewardType === 'COUPON') {
        return COUPON_NAME[this.awardData.detail.businessType];
      }
      return AWARD_NAME[this.awardData.rewardType] || '';
    },
    timeText() {
      switch (this.awardData.rewardType) {
        case 'ENTITY':
          return `请于${this.actEndTimeStr}活动结束前填写收货地址`;
        default:
          if (
            this.awardData &&
            this.awardData.startTime &&
            this.awardData.endTime
          ) {
            return `有效期：${toDayDate(this.awardData.startTime)}-${toDayDate(
              this.awardData.endTime
            )}`;
          }
      }
      return '';
    },
    btnText() {
      return this.isHasUserAddress ? '修改地址' : '填写地址';
    }
  },
  filters: {
    formatTime: v => {
      return v
        ? formatTime(
            'yyyy.MM.dd',
            new Date(typeof v === 'string' ? v.replace(/-/g, '/') : v)
          )
        : '';
    }
  },
  methods: {
    handleUseCoupon(award) {
      useCoupon(award.businesstType);
    },
    handleUseAward(award) {
      location.href = award.clickUrl;
    },
    handleGoAddressPage() {
      this.$router.push('/contact');
    },
    handleClick() {
      if (!this.awardData.clickUrl) return;
      location.href = this.awardData.clickUrl;
    }
  }
};
</script>

<style lang="less" scoped>
.awardItem {
  margin: 0 auto 24px;
  display: flex;
  padding: 30px 24px;
  background-color: #fff;
  align-items: center;

  .awardIcon {
    flex: 140px 0 0;
    padding-right: 32px;
    height: 140px;
    font-size: 32px;
  }

  .main {
    flex-grow: 1;
    min-height: 140px;
    flex: 1;
    .titleArea {
      display: flex;
      align-items: center;
      line-height: normal;
      overflow: hidden;
      .label {
        margin-right: 14px;
        padding: 0 10px;
        font-size: 24px;
        color: #ff6600;
        border: 2px solid #ff6600;
        border-radius: 7px;
      }

      .title {
        flex: 0 0 385px;
        font-size: 32px;
        color: #262626;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
      }
    }

    .time {
      margin-top: 5px;
      height: 38px;
      font-size: 26px;
      color: #8c8c8c;
    }

    .btn {
      margin-top: 15px;
      margin-right: 10px;
      float: right;
      width: 160px;
      height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: normal;
      font-size: 26px;
      color: #ffffff;
      background: linear-gradient(to top, #ff7e00 0%, #ff9600 39%, #ffb80f 99%);
      border-radius: 24px;
    }
  }
}
</style>
